export const USER_CAN_VIEW_VESSEL_TRACKING = 'tolaut@user_can_view_vessel_tracking'
export const USER_CAN_VIEW_REGISTERED_USER = 'tolaut@user_can_view_registered_user'
export const USER_CAN_VIEW_TOTAL_ORDER = 'tolaut@user_can_view_total_order'
export const USER_CAN_VIEW_PAID_ORDER = 'tolaut@user_can_view_paid_order'
export const USER_CAN_VIEW_UNPAID_ORDER = 'tolaut@user_can_view_unpaid_order'
export const USER_CAN_VIEW_REJECTED_ORDER = 'tolaut@user_can_view_rejected_order'
export const USER_CAN_VIEW_ORDER_THIS_MONTH = 'tolaut@user_can_view_order_this_month'
export const USER_CAN_VIEW_OPERATOR_LIST = 'tolaut@user_can_view_operator_list'
export const USER_CAN_VIEW_TOTAL_REALISASI = 'tolaut@user_can_view_total_realisasi'
export const USER_CAN_VIEW_DISPARITAS_HARGA = 'tolaut@user_can_view_disparitas_harga'
export const USER_CAN_VIEW_SISA_KUOTA = 'tolaut@user_can_view_sisa_kuota'
export const USER_CAN_VIEW_TOTAL_MUATAN = 'tolaut@user_can_view_total_muatan'
export const USER_CAN_VIEW_REALISASI_VOYAGE = 'tolaut@user_can_view_realisasi_voyage'
export const USER_CAN_VIEW_WAKTU_TEMPUH = 'tolaut@user_can_view_waktu_tempuh'
export const USER_CAN_VIEW_TOTAL_ORDER_PER_PRIORITAS = 'tolaut@user_can_view_total_order_per_prioritas'
export const USER_CAN_VIEW_5_JENIS_MUATAN_PER_PRIORITAS = 'tolaut@user_can_view_5_jenis_muatan_per_prioritas'
export const USER_CAN_VIEW_VOYAGE_PER_TRAYEK = 'tolaut@user_can_view_voyage_per_trayek'
export const USER_CAN_VIEW_TOTAL_CONTAINER_PER_PORT = 'tolaut@user_can_view_total_container_per_port'
export const USER_CAN_VIEW_REPORT = 'tolaut@user_can_view_report'

export const USER_CAN_VIEW_LATEST_PO = 'tolaut@user_can_view_latest_po'
export const USER_CAN_VIEW_PO_LIST = 'tolaut@user_can_view_po_list'
export const USER_CAN_VIEW_PO_DETAIL = 'tolaut@user_can_view_po_detail'
export const USER_CAN_CREATE_PO = 'tolaut@user_can_create_po'
export const USER_CAN_ENABLE_PO = 'tolaut@user_can_enable_menu'

export const USER_CAN_MANIFEST_LIST = 'tolaut@user_can_manifest_list'
export const USER_CAN_MANIFEST_DETAIL = 'tolaut@user_can_manifest_detail'
export const USER_CAN_MANIFEST_PRINT = 'tolaut@user_can_manifest_print'

export const USER_CAN_BOOKING_LIST = 'tolaut@user_can_booking_list'
export const USER_CAN_BOOKING_DETAIL = 'tolaut@user_can_booking_detail'
export const USER_CAN_BOOKING_CREATE = 'tolaut@user_can_booking_create'
export const USER_CAN_VIEW_LATEST_VESSEL_BOOKING = 'tolaut@user_can_view_latest_vessel_booking'

export const USER_CAN_JENIS_BARANG_CREATE = 'tolaut@user_can_jenis_barang_create'
export const USER_CAN_JENIS_BARANG_LIST = 'tolaut@user_can_jenis_barang_list'
export const USER_CAN_JENIS_BARANG_DETAIL = 'tolaut@user_can_jenis_barang_detail'
export const USER_CAN_JENIS_BARANG_UPDATE = 'tolaut@user_can_jenis_barang_update'
export const USER_CAN_JENIS_BARANG_DELETE = 'tolaut@user_can_jenis_barang_delete'

export const USER_CAN_JENIS_KOMODITAS_CREATE = 'tolaut@user_can_jenis_komoditas_create'
export const USER_CAN_JENIS_KOMODITAS_LIST = 'tolaut@user_can_jenis_komoditas_list'
export const USER_CAN_JENIS_KOMODITAS_DETAIL = 'tolaut@user_can_jenis_komoditas_detail'
export const USER_CAN_JENIS_KOMODITAS_UPDATE = 'tolaut@user_can_jenis_komoditas_update'
export const USER_CAN_JENIS_KOMODITAS_DELETE = 'tolaut@user_can_jenis_komoditas_delete'

export const USER_CAN_BARANG_PENTING_CREATE = 'tolaut@user_can_barang_penting_create'
export const USER_CAN_BARANG_PENTING_LIST = 'tolaut@user_can_barang_penting_list'
export const USER_CAN_BARANG_PENTING_DETAIL = 'tolaut@user_can_barang_penting_detail'
export const USER_CAN_BARANG_PENTING_UPDATE = 'tolaut@user_can_barang_penting_update'
export const USER_CAN_BARANG_PENTING_DELETE = 'tolaut@user_can_barang_penting_delete'

export const USER_CAN_KEMASAN_CREATE = 'tolaut@user_can_kemasan_create'
export const USER_CAN_KEMASAN_LIST = 'tolaut@user_can_kemasan_list'
export const USER_CAN_KEMASAN_DETAIL = 'tolaut@user_can_kemasan_detail'
export const USER_CAN_KEMASAN_UPDATE = 'tolaut@user_can_kemasan_update'
export const USER_CAN_KEMASAN_DELETE = 'tolaut@user_can_kemasan_delete'

export const USER_CAN_SATUAN_CREATE = 'tolaut@user_can_satuan_create'
export const USER_CAN_SATUAN_LIST = 'tolaut@user_can_satuan_list'
export const USER_CAN_SATUAN_DETAIL = 'tolaut@user_can_satuan_detail'
export const USER_CAN_SATUAN_UPDATE = 'tolaut@user_can_satuan_update'
export const USER_CAN_SATUAN_DELETE = 'tolaut@user_can_satuan_delete'

export const USER_CAN_MASTER_TARIF_CREATE = 'tolaut@user_can_master_tarif_create'
export const USER_CAN_MASTER_TARIF_LIST = 'tolaut@user_can_master_tarif_list'
export const USER_CAN_MASTER_TARIF_DETAIL = 'tolaut@user_can_master_tarif_detail'
export const USER_CAN_MASTER_TARIF_UPDATE = 'tolaut@user_can_master_tarif_update'
export const USER_CAN_MASTER_TARIF_DELETE = 'tolaut@user_can_master_tarif_delete'

export const USER_CAN_TIPE_KONTAINER_CREATE = 'tolaut@user_can_tipe_kontainer_create'
export const USER_CAN_TIPE_KONTAINER_LIST = 'tolaut@user_can_tipe_kontainer_list'
export const USER_CAN_TIPE_KONTAINER_DETAIL = 'tolaut@user_can_tipe_kontainer_detail'
export const USER_CAN_TIPE_KONTAINER_UPDATE = 'tolaut@user_can_tipe_kontainer_update'
export const USER_CAN_TIPE_KONTAINER_DELETE = 'tolaut@user_can_tipe_kontainer_delete'

export const USER_CAN_KAPAL_CREATE = 'tolaut@user_can_kapal_create'
export const USER_CAN_KAPAL_LIST = 'tolaut@user_can_kapal_list'
export const USER_CAN_KAPAL_VIEW = 'tolaut@user_can_kapal_view'
export const USER_CAN_KAPAL_UPDATE = 'tolaut@user_can_kapal_update'
export const USER_CAN_KAPAL_DELETE = 'tolaut@user_can_kapal_delete'

export const USER_CAN_TRACKING_DATA_LIST = 'tolaut@user_can_tracking_data_list'
export const USER_CAN_TRACKING_LIST = 'tolaut@user_can_tracking_list'
export const USER_CAN_TRACKING_VIEW = 'tolaut@user_can_tracking_view'

export const USER_CAN_PENGADUAN_LIST = 'tolaut@user_can_pengaduan_list'
export const USER_CAN_PENGADUAN_VIEW = 'tolaut@user_can_pengaduan_view'
export const USER_CAN_PENGADUAN_REPLY = 'tolaut@user_can_pengaduan_reply'
export const USER_CAN_SET_TO_CLOSE = 'tolaut@user_can_set_to_close'

export const USER_CAN_ACTIVATION_USER_LIST = 'tolaut@user_can_activation_user_list'
export const USER_CAN_ACTIVATION_USER_DETAIL = 'tolaut@user_can_activation_user_detail'
export const USER_CAN_ACTIVATION_USER_ACTIVATE = 'tolaut@user_can_activation_user_activate'
export const USER_CAN_ACTIVATION_USER_DEACTIVATE = 'tolaut@user_can_activation_user_deactivate'

export const USER_CAN_USER_LIST = 'tolaut@user_can_user_list'
export const USER_CAN_USER_DETAIL = 'tolaut@user_can_user_detail'
export const USER_CAN_USER_DELETE = 'tolaut@user_can_user_delete'
export const USER_CAN_USER_RESET_PASSWORD = 'tolaut@user_can_user_reset_password'
export const USER_CAN_USER_UPDATE = 'tolaut@user_can_user_update'

export const USER_CAN_USER_CONSIGNEE_LIST = 'tolaut@user_can_consignee_list'
export const USER_CAN_USER_CONSIGNEE_DETAIL = 'tolaut@user_can_consignee_detail'
export const USER_CAN_USER_CONSIGNEE_DELETE = 'tolaut@user_can_consignee_delete'
export const USER_CAN_USER_CONSIGNEE_RESET_PASSWORD = 'tolaut@user_can_consignee_reset_password'

export const USER_CAN_USER_SUPPLIER_LIST = 'tolaut@user_can_supplier_list'
export const USER_CAN_USER_SUPPLIER_DETAIL = 'tolaut@user_can_supplier_detail'
export const USER_CAN_USER_SUPPLIER_DELETE = 'tolaut@user_can_supplier_delete'
export const USER_CAN_USER_SUPPLIER_RESET_PASSWORD = 'tolaut@user_can_supplier_reset_password'

export const USER_CAN_USER_SHIPPER_LIST = 'tolaut@user_can_shipper_list'
export const USER_CAN_USER_SHIPPER_DETAIL = 'tolaut@user_can_shipper_detail'
export const USER_CAN_USER_SHIPPER_DELETE = 'tolaut@user_can_shipper_delete'
export const USER_CAN_USER_SHIPPER_RESET_PASSWORD = 'tolaut@user_can_shipper_reset_password'

export const USER_CAN_USER_OPERATOR_LIST = 'tolaut@user_can_operator_list'
export const USER_CAN_USER_OPERATOR_DETAIL = 'tolaut@user_can_operator_detail'
export const USER_CAN_USER_OPERATOR_DELETE = 'tolaut@user_can_operator_delete'
export const USER_CAN_USER_OPERATOR_RESET_PASSWORD = 'tolaut@user_can_operator_reset_password'

export const USER_CAN_USER_RESELLER_LIST = 'tolaut@user_can_reseller_list'
export const USER_CAN_USER_RESELLER_DETAIL = 'tolaut@user_can_reseller_detail'
export const USER_CAN_USER_RESELLER_DELETE = 'tolaut@user_can_reseller_delete'
export const USER_CAN_USER_RESELLER_RESET_PASSWORD = 'tolaut@user_can_reseller_reset_password'

export const USER_CAN_REGULATOR_CREATE = 'tolaut@user_can_regulator_create'
export const USER_CAN_REGULATOR_LIST = 'tolaut@user_can_regulator_list'
export const USER_CAN_REGULATOR_DETAIL = 'tolaut@user_can_regulator_detail'
export const USER_CAN_REGULATOR_UPDATE = 'tolaut@user_can_regulator_update'
export const USER_CAN_REGULATOR_DELETE = 'tolaut@user_can_regulator_delete'

export const USER_CAN_PENERIMAAN_BARANG_LIST = 'tolaut@user_can_penerimaan_barang_list'
export const USER_CAN_DISTRIBUSI_BARANG_LIST = 'tolaut@user_can_distribusi_barang_list'
export const USER_CAN_VIEW_LATEST_DISTRIBUSI_BARANG = 'tolaut@user_can_view_latest_distribusi_barang'
export const USER_CAN_VIEW_LATEST_BARANG = 'tolaut@user_can_view_latest_barang'

export const USER_CAN_HARGA_JUAL_BARANG_LIST = 'tolaut@user_can_harga_jual_barang_list'
export const USER_CAN_HARGA_JUAL_BARANG_CREATE = 'tolaut@user_can_harga_jual_barang_create'

export const USER_CAN_KOMODITAS_CREATE = 'tolaut@user_can_komoditas_create'
export const USER_CAN_KOMODITAS_LIST = 'tolaut@user_can_komoditas_list'
export const USER_CAN_KOMODITAS_DETAIL = 'tolaut@user_can_komoditas_detail'
export const USER_CAN_KOMODITAS_UPDATE = 'tolaut@user_can_komoditas_update'
export const USER_CAN_KOMODITAS_DELETE = 'tolaut@user_can_komoditas_delete'
export const USER_CAN_VIEW_LATEST_KOMODITAS = 'tolaut@user_can_view_latest_komoditas'

export const USER_CAN_BIAYA_PENGURUSAN_CREATE = 'tolaut@user_can_biaya_pengurusan_create'
export const USER_CAN_BIAYA_PENGURUSAN_LIST = 'tolaut@user_can_biaya_pengurusan_list'
export const USER_CAN_BIAYA_PENGURUSAN_DETAIL = 'tolaut@user_can_biaya_pengurusan_detail'
export const USER_CAN_BIAYA_PENGURUSAN_UPDATE = 'tolaut@user_can_biaya_pengurusan_update'
export const USER_CAN_BIAYA_PENGURUSAN_DELETE = 'tolaut@user_can_biaya_pengurusan_delete'

export const USER_CAN_BARANG_LIST = 'tolaut@user_can_barang_list'
export const USER_CAN_BARANG_CREATE = 'tolaut@user_can_barang_create'

export const USER_CAN_TRAYEK_CREATE = 'tolaut@user_can_trayek_create'
export const USER_CAN_TRAYEK_LIST = 'tolaut@user_can_trayek_list'
export const USER_CAN_TRAYEK_DETAIL = 'tolaut@user_can_trayek_detail'
export const USER_CAN_TRAYEK_UPDATE = 'tolaut@user_can_trayek_update'
export const USER_CAN_TRAYEK_DELETE = 'tolaut@user_can_trayek_delete'
export const USER_CAN_VIEW_SISA_QUOTA_TRAYEK = 'tolaut@user_can_view_sisa_quota_trayek'

export const USER_CAN_PELABUHAN_CREATE = 'tolaut@user_can_pelabuhan_create'
export const USER_CAN_PELABUHAN_LIST = 'tolaut@user_can_pelabuhan_list'
export const USER_CAN_PELABUHAN_DETAIL = 'tolaut@user_can_pelabuhan_detail'
export const USER_CAN_PELABUHAN_UPDATE = 'tolaut@user_can_pelabuhan_update'
export const USER_CAN_PELABUHAN_DELETE = 'tolaut@user_can_pelabuhan_delete'

export const USER_CAN_DEPOT_CREATE = 'tolaut@user_can_depot_create'
export const USER_CAN_DEPOT_LIST = 'tolaut@user_can_depot_list'
export const USER_CAN_DEPOT_DETAIL = 'tolaut@user_can_depot_detail'
export const USER_CAN_DEPOT_UPDATE = 'tolaut@user_can_depot_update'
export const USER_CAN_DEPOT_DELETE = 'tolaut@user_can_depot_delete'

export const USER_CAN_JADWAL_CREATE = 'tolaut@user_can_jadwal_create'
export const USER_CAN_JADWAL_HISTORY = 'tolaut@user_can_jadwal_history'
export const USER_CAN_JADWAL_LIST = 'tolaut@user_can_jadwal_list'
export const USER_CAN_JADWAL_DETAIL = 'tolaut@user_can_jadwal_detail'
export const USER_CAN_JADWAL_UPDATE = 'tolaut@user_can_jadwal_update'
export const USER_CAN_JADWAL_DELETE = 'tolaut@user_can_jadwal_delete'
export const USER_CAN_VIEW_LATEST_JADWAL_KAPAL = 'tolaut@user_can_view_latest_jadwal_kapal'

export const USER_CAN_VIEW_PORTAL = 'tolaut@user_can_view_portal'
export const USER_CAN_VIEW_PORTAL_MENU = 'tolaut@user_can_view_portal_menu'
export const USER_CAN_VIEW_PORTAL_CONTENT = 'tolaut@user_can_view_portal_content'
export const USER_CAN_ADD_PORTAL_MENU= 'tolaut@user_can_add_portal_menu'
export const USER_CAN_ADD_PORTAL_CONTENT= 'tolaut@user_can_add_portal_content'
